module.exports = "/static-assets/_next/static/images/img-b7e12fe94b-44269f00f89c897096fc83c00c1ae07d.webp";